import { Badge, Tooltip } from "@chakra-ui/react";
import { useResolvedPath } from "react-router";

import { useDebugProblemCount } from "@/app/data/useDebugProblemCount";
import { SidebarToggleButton } from "@/common/components/CommonIconButtons";
import HeaderLayout from "@/common/components/HeaderLayout";
import RouterTabs, {
  Route,
  useActivePathRouteIndex,
} from "@/common/components/RouterTabs";
import { useFlag } from "@reflag/react-sdk";

export default function Tracking() {
  const { isEnabled: problemsEnabled } = useFlag("event-log-problem-filter");
  const { data: problemCount } = useDebugProblemCount(problemsEnabled);
  const problemsPath = useResolvedPath("problems").pathname;
  const tabsRoutes: Route[] = [
    {
      route: useResolvedPath("recent").pathname,
      name: "Recent",
    },
    {
      route: useResolvedPath("distinct").pathname,
      name: "Distinct",
    },
  ];
  if (problemsEnabled) {
    tabsRoutes.splice(1, 0, {
      route: problemsPath,
      name: "Problems",
      badge:
        problemCount !== undefined && problemCount > 0 ? (
          <Tooltip label="Problems detected in the last 24 hours">
            <Badge
              ml={2}
              borderRadius="full"
              colorScheme="orange"
              variant="subtle"
              px={1.5}
              aria-label={`${problemCount} problems detected in the last 24 hours`}
            >
              {problemCount.toLocaleString()}
            </Badge>
          </Tooltip>
        ) : undefined,
    });
  }
  const activeRouteIndex = useActivePathRouteIndex(tabsRoutes);

  return (
    <HeaderLayout title="Event log" borderless>
      <RouterTabs
        activeRouteIndex={activeRouteIndex}
        rightActions={<SidebarToggleButton sidebarKey="debugger" />}
        routes={tabsRoutes}
        tabListProps={{ px: 3 }}
        titleTemplate="Event log › %s"
      />
    </HeaderLayout>
  );
}
